var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { SgdfElement } from '../../internal/sgdf-element';
import styles from './entities-search.styles';
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import '@shoelace-style/shoelace/dist/components/tab/tab.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';
import '../../atoms/icon/icon.js';
import './cards/result-card.js';
import { matchSorter } from '../../internal/search';
import { getFirstNameWithLastNameInitial, getFullName, } from '../../helpers/nameHelpers';
function participantToEntity(participant) {
    var _a;
    return {
        name: `${getFullName(participant)}`,
        description: `${(_a = participant.structure_principale) === null || _a === void 0 ? void 0 : _a.label} - ${participant.fonction}`,
        type: 'participant',
        picture: participant.avatar_available
            ? participant.avatar_url
            : participant.user_avatar_available
                ? participant.user_avatar_url
                : undefined,
        id: participant.id,
    };
}
function teamToEntity(team, type) {
    return {
        name: `${team.label}`,
        description: `${team.participants
            .map(p => getFirstNameWithLastNameInitial(p))
            .join(', ')}`,
        type,
        id: team.id,
    };
}
let SgdfEntitiesSearch = class SgdfEntitiesSearch extends SgdfElement {
    constructor() {
        super(...arguments);
        this.teams = [];
        this.dailyTaskTeams = [];
        this.participants = [];
        this.content = [];
        this.searchResults = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.onSearchChange = this.onSearchChange.bind(this);
        this.updateComplete.then(() => {
            var _a, _b, _c, _d, _e, _f, _g;
            (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.addEventListener('sl-input', this.onSearchChange);
            this.content = [
                ...((_c = (_b = this.participants) === null || _b === void 0 ? void 0 : _b.map(participantToEntity)) !== null && _c !== void 0 ? _c : []),
                ...((_e = (_d = this.teams) === null || _d === void 0 ? void 0 : _d.map(team => teamToEntity(team, 'team'))) !== null && _e !== void 0 ? _e : []),
                ...((_g = (_f = this.dailyTaskTeams) === null || _f === void 0 ? void 0 : _f.map(dailyTaskTeam => teamToEntity(dailyTaskTeam, 'daily-task-team'))) !== null && _g !== void 0 ? _g : []),
            ];
            this.searchResults = this.content;
        });
    }
    onSearchChange() {
        this.searchResults = matchSorter(this.content, this.searchInput.value, {
            keys: ['name', 'description'],
        });
    }
    willUpdate(changedProperties) {
        var _a, _b, _c, _d, _e, _f;
        if (changedProperties.has('teams') ||
            changedProperties.has('dailyTaskTeams') ||
            changedProperties.has('participants')) {
            this.content = [
                ...((_b = (_a = this.participants) === null || _a === void 0 ? void 0 : _a.map(participantToEntity)) !== null && _b !== void 0 ? _b : []),
                ...((_d = (_c = this.teams) === null || _c === void 0 ? void 0 : _c.map(team => teamToEntity(team, 'team'))) !== null && _d !== void 0 ? _d : []),
                ...((_f = (_e = this.dailyTaskTeams) === null || _e === void 0 ? void 0 : _e.map(dailyTaskTeam => teamToEntity(dailyTaskTeam, 'daily-task-team'))) !== null && _f !== void 0 ? _f : []),
            ];
            this.searchResults = this.content;
        }
    }
    render() {
        const participantResults = this.searchResults.filter(r => r.type === 'participant');
        const teamResults = this.searchResults.filter(r => r.type === 'team');
        return html `<div class="container">
            <sl-input class="search-input" placeholder="Rechercher" clearable>
                <sgdf-icon name="magnifying-glass" slot="prefix"></sgdf-icon>
            </sl-input>
            <sl-tab-group>
                <sl-tab slot="nav" panel="all"
                    >Tous (${this.searchResults.length})</sl-tab
                >
                <sl-tab slot="nav" panel="participant"
                    ><div class="nav-item">
                        <sgdf-icon name="user"></sgdf-icon> Participants
                        (${participantResults.length})
                    </div></sl-tab
                >
                <sl-tab slot="nav" panel="team"
                    ><div class="nav-item">
                        <sgdf-icon name="users"></sgdf-icon> Equipes
                        (${teamResults.length})
                    </div></sl-tab
                >
                <sl-tab-panel name="all">
                    <ul class="list">
                        ${this.searchResults.map((result) => html `
                                <li
                                    class="mention"
                                >
                                    <sgdf-result-card
                                        .result=${result}
                                    ></sgdf-result-card>
                                </li>
                            `)}
                    </ul>
                </sl-tab-panel>
                <sl-tab-panel name="participant">
                    <ul class="list">
                        ${participantResults.map((result) => html `
                                <li
                                    class="mention"
                                >
                                    <sgdf-result-card
                                        .result=${result}
                                    ></sgdf-result-card>
                                </li>
                            `)}
                    </ul>
                </sl-tab-panel>
                <sl-tab-panel name="team">
                    <ul class="list">
                        ${teamResults.map((result) => html `
                                <li
                                    class="mention"
                                >
                                    <sgdf-result-card
                                        .result=${result}
                                    ></sgdf-result-card>
                                </li>
                            `)}
                    </ul></sl-tab-panel
                >
            </sl-tab-group>
        </div> `;
    }
};
SgdfEntitiesSearch.styles = styles;
__decorate([
    property({ type: Array, reflect: true })
], SgdfEntitiesSearch.prototype, "teams", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfEntitiesSearch.prototype, "dailyTaskTeams", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfEntitiesSearch.prototype, "participants", void 0);
__decorate([
    state()
], SgdfEntitiesSearch.prototype, "searchResults", void 0);
__decorate([
    query('.search-input')
], SgdfEntitiesSearch.prototype, "searchInput", void 0);
__decorate([
    query('.all-list')
], SgdfEntitiesSearch.prototype, "list", void 0);
SgdfEntitiesSearch = __decorate([
    customElement('sgdf-entities-search')
], SgdfEntitiesSearch);
export default SgdfEntitiesSearch;
//# sourceMappingURL=entities-search.js.map